export class FilterRelativeDateUnitError extends Error {
  public constructor() {
    super('unit is invalid')
  }
}